// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-product-modal-modal_card-Xpf0D {
  width: 340px;
  height: auto;
}

.edit-product-modal-textField_container-hUkCz, .edit-product-modal-select_container-Jowqw {
  width: 100%;
  margin-top: 24px;
}

.edit-product-modal-product-pGzyp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.edit-product-modal-productLabel-eRhsZ {
  font-size: 14px;
  color: var(--color-neutral-800);
}

.edit-product-modal-productContent-vWlx6 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.edit-product-modal-productImage-v7VRs {
  width: 28px;
  height: 28px;
}

.edit-product-modal-productName-ShrE0 {
  font-size: 16px;
  color: var(--color-neutral-900);
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/products/edit-product-modal/edit-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.textField_container, .select_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.product {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.productLabel {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n\n.productContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.productImage {\n  width: 28px;\n  height: 28px;\n}\n\n.productName {\n  font-size: 16px;\n  color: var(--color-neutral-900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-product-modal-modal_card-Xpf0D`,
	"textField_container": `edit-product-modal-textField_container-hUkCz`,
	"select_container": `edit-product-modal-select_container-Jowqw`,
	"product": `edit-product-modal-product-pGzyp`,
	"productLabel": `edit-product-modal-productLabel-eRhsZ`,
	"productContent": `edit-product-modal-productContent-vWlx6`,
	"productImage": `edit-product-modal-productImage-v7VRs`,
	"productName": `edit-product-modal-productName-ShrE0`
};
export default ___CSS_LOADER_EXPORT___;
